import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import media from '../../styles/media.style';
import Markdown from '../../components/Markdown';
import Placeholder from '../../components/Placeholder';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

const Section = styled.section`
  box-sizing: content-box;
  margin-top: 30px;
  padding: 0 ${MOBILE_PADDING}px;
  width: calc(100% - ${MOBILE_PADDING * 2}px);

  ${media.tabletL`
    display: flex;
    justify-content: space-between;
    margin: 60px auto;
    max-width: ${SCREEN_LOCKUP_WIDTH}px;
  `};
`;

const Title = styled.div`
  font-size: 28px;
  font-weight: 500;
  line-height: 1.07;
  letter-spacing: 0.3px;

  ${media.tabletL`
    font-size: 38px;
    line-height: 1.26;
    letter-spacing: 0.5px;
    width: 45%;
  `};
`;

const Description = styled.div`
  margin-top: 35px;

  ${media.tabletL`
    margin-top: 0; 
    width: 45%;
  `};

  p {
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: 0.1px;
    margin: 40px 0 0 0;

    ${media.tabletL`
      font-size: 18px;
    `};

    :first-child {
      margin: 0;
    }
  }
`;

const IntroSection = ({ title, description }) => (
  <Section>
    <Title>{title || <Placeholder w="70%" h="40px" />}</Title>
    {description ? (
      <Markdown Component={Description} src={description} />
    ) : (
      <Description>
        <Placeholder w="100%" pb="60%" />
      </Description>
    )}
  </Section>
);

IntroSection.defaultProps = {
  title: undefined,
  description: undefined,
};

IntroSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default IntroSection;



// WEBPACK FOOTER //
// ./src/pages/HeritagePage/IntroSection.js